import { SearchableCombobox, TSearchable } from '@/components/base/combobox'

interface Props {
  value: string
  onChange: (value: TSearchable | null) => void
  invalid: boolean
  options: {
    id: string
    value: string
  }[]
}

export const Selector = ({ value, onChange, invalid, options }: Props) => {
  const items = options.map(option => ({ id: option.id, name: option.value }))

  return (
    <SearchableCombobox
      data={items}
      fetchMore={() => {}}
      includeBlank={false}
      invalid={invalid}
      loading={false}
      moreToFetch={false}
      refetch={() => {}}
      searchField=""
      value={items.find(d => d.id == value) || { id: value, name: value }}
      onChange={onChange}
    />
  )
}
